export default [
  {
    path: "/company",
    component: () =>
      import(/* webpackChunkName: "company" */ "@/views/Company/pages"),
    children: [
      {
        path: "/",
        name: "Company",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/Company"
          ),
      },
      {
        path: "register-position",
        name: "RegisterPosition",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/Positions/Register"
          ),
      },
      {
        path: "list-positions",
        name: "ListPositions",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/Positions/List"
          ),
      },
      {
        path: ":id/edit-position",
        name: "EditPosition",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/Positions/Register"
          ),
      },
      {
        path: "register-department",
        name: "RegisterDepartment",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/Departments/Register"
          ),
      },
      {
        path: "list-departments",
        name: "ListDepartments",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/Departments/List"
          ),
      },
      {
        path: ":id/edit-department",
        name: "EditDepartment",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/Departments/Register"
          ),
      },
      {
        path: "register-lead-status",
        name: "RegisterLeadStatus",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/LeadsStatus/Register"
          ),
      },
      {
        path: "list-leads-status",
        name: "ListLeadsStatus",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/LeadsStatus/List"
          ),
      },
      {
        path: ":id/edit-lead-status",
        name: "EditLeadStatus",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/LeadsStatus/Register"
          ),
      },
      {
        path: "leads",
        name: "Leads",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/Leads"
          ),
      },
      {
        path: "register-plan",
        name: "RegisterCompanyPlans",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/Plans/Register"
          ),
      },
      {
        path: "list-plans",
        name: "ListCompanyPlans",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/Plans/List"
          ),
      },
      {
        path: ":id/edit-plan",
        name: "EditCompanyPlans",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/Plans/Register"
          ),
      },
      {
        path: "register-company",
        name: "RegisterCompany",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/Company/Register"
          ),
      },
      {
        path: "list-companies",
        name: "ListCompanies",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/Company/List"
          ),
      },
      {
        path: ":id/:slug/edit-company",
        name: "EditCompany",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/Company/Register"
          ),
      },
      {
        path: ":id/:slug/menu-company",
        name: "MenuCompany",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/Company/Menu"
          ),
      },
      {
        path: ":id/:slug/list-plans",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/Company/Plan"
          ),
        children: [
          {
            path: "/",
            name: "ListPlansCompany",
            component: () =>
              import(
                /* webpackChunkName: "company" */ "@/views/Company/pages/Company/Plan/List"
              ),
          },
          {
            path: "register-plan-company",
            name: "RegisterPlanCompany",
            component: () =>
              import(
                /* webpackChunkName: "company" */ "@/views/Company/pages/Company/Plan/Register"
              ),
          },
          {
            path: ":idCompanyHasPlan/edit-plan-company",
            name: "EditPlanCompany",
            component: () =>
              import(
                /* webpackChunkName: "company" */ "@/views/Company/pages/Company/Plan/Register"
              ),
          },
        ],
      },
      {
        path: ":id/:slug/list-admins",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/Company/Admin"
          ),
        children: [
          {
            path: "/",
            name: "ListAdminsCompany",
            component: () =>
              import(
                /* webpackChunkName: "company" */ "@/views/Company/pages/Company/Admin/List"
              ),
          },
          {
            path: "register-admin-company",
            name: "RegisterAdminCompany",
            component: () =>
              import(
                /* webpackChunkName: "company" */ "@/views/Company/pages/Company/Admin/Register"
              ),
          },
          {
            path: ":idCompanyAdmin/edit-admin-company",
            name: "EditAdminCompany",
            component: () =>
              import(
                /* webpackChunkName: "company" */ "@/views/Company/pages/Company/Admin/Register"
              ),
          },
        ],
      },
      {
        path: ":id/:slug/list-professionals",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/Company/Professional"
          ),
        children: [
          {
            path: "/",
            name: "ListProfessionalsCompany",
            component: () =>
              import(
                /* webpackChunkName: "company" */ "@/views/Company/pages/Company/Professional/List"
              ),
          },
          {
            path: ":idProfessional/register-professional-company",
            name: "RegisterProfessionalCompany",
            component: () =>
              import(
                /* webpackChunkName: "company" */ "@/views/Company/pages/Company/Professional/Details"
              ),
          },
          {
            path: ":idProfessional/edit-professional-company/:idCompanyHasProfessional",
            name: "EditProfessionalCompany",
            component: () =>
              import(
                /* webpackChunkName: "company" */ "@/views/Company/pages/Company/Professional/Details"
              ),
          },
        ],
      },
      {
        path: ":id/:slug/list-collaborators",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/Company/Collaborator"
          ),
        children: [
          {
            path: "/",
            name: "ListCollaboratorsCompany",
            component: () =>
              import(
                /* webpackChunkName: "company" */ "@/views/Company/pages/Company/Collaborator/List"
              ),
          },
          {
            path: "register-collaborator-company",
            name: "RegisterCollaboratorCompany",
            component: () =>
              import(
                /* webpackChunkName: "company" */ "@/views/Company/pages/Company/Collaborator/Register"
              ),
          },
          {
            path: ":idCompanyCollaborator/edit-collaborator-company",
            name: "EditCollaboratorCompany",
            component: () =>
              import(
                /* webpackChunkName: "company" */ "@/views/Company/pages/Company/Collaborator/Register"
              ),
          },
        ],
      },
    ],
  },
];
